import * as aor from "react-admin";
import React from "react";
import MainCompanySelect from "../../components/MainCompanySelect";
import { Field } from "redux-form";
import {
    getPolicies,
    getUserCompany,
    getUserCompanyRole
} from "../../common/authClient";
import { POLICY_COMPANIES } from "../../common/rolesManagement";
import myRestClient from "../../common/restClient";
import PermissionDenied from "../../components/PermissionDenied";
import AutoCompleteInputOld from "../../components/AutoCompleteInputOld";
const typeOptions = {
    resource: "installation_types",
    display: "name",
    label: "Può gestire installazioni:",
    placeholder: "Tipi installazioni",
    isMulti: true,
    notRequired: true
};

const MY_COMPANY_ID = getUserCompany();

const MyToolbar = props => (
    <aor.Toolbar {...props}>
        <aor.SaveButton redirect="show" submitOnEnter={true} />
    </aor.Toolbar>
);

const reg = /^[A-Za-z0-9]+$/;
const notspecial = (
    message = "resources.companies.validation.notSpecialCharacter"
) => (value, allValues, props) =>
    value && !reg.test(value) ? props.translate(message) : undefined;
class MyCreateCompanyForm extends React.Component {
    state = { form_visible: false, data_fetched: false };

    // The component in the case of an admin_ts_var user checks if the login company is master or controlled
    // in case it is a master, it shows the create form, otherwise it doesn't
    componentWillReceiveProps(nextProps) {
        if (
            nextProps.permissions &&
            (nextProps.permissions.includes(POLICY_COMPANIES.CREATE) ||
                nextProps.permissions.includes(POLICY_COMPANIES.SAFE_CREATE))
        ) {
            if (nextProps.permissions.includes(POLICY_COMPANIES.SAFE_CREATE)) {
                if (!this.state.data_fetched) {
                    myRestClient("GET_ONE", "companies", {
                        id: MY_COMPANY_ID
                    }).then(
                        result => {
                            const visible = result.data.master_company_id
                                ? false
                                : true;
                            this.setState({
                                form_visible: visible,
                                data_fetched: true
                            });
                        },
                        error => {
                            console.log(error);
                            this.setState({ form_visible: false });
                        }
                    );
                }
            } else {
                this.setState({ form_visible: true, data_fetched: true });
            }
        }
    }

    render() {
        const { permissions, ...props } = this.props;
        if (this.state.data_fetched) {
            if (this.state.form_visible) {
                const {
                    hasCreate,
                    hasEdit,
                    hasList,
                    hasShow,
                    ...sanitizedProps
                } = props;
                return (
                    <aor.SimpleForm toolbar={<MyToolbar />} {...sanitizedProps}>
                        <aor.TextInput
                            source="vatin"
                            validate={[aor.required(), notspecial()]}
                            format={v => (v ? v.toUpperCase() : "")}
                        />
                        <aor.TextInput
                            source="name"
                            validate={[aor.required()]}
                        />
                        <aor.TextInput
                            source="seller_code"
                            validate={[aor.required()]}
                        />
                        <Field
                            {...props}
                            name="master_company_id"
                            component={props => (
                                <MainCompanySelect
                                    locked_on_login_company={getPolicies(
                                        getUserCompanyRole()
                                    ).includes(
                                        POLICY_COMPANIES.FILTER_LIMIT_COMPANIES
                                    )}
                                    {...props}
                                />
                            )}
                        />
                        {permissions &&
                            permissions.includes(
                                POLICY_COMPANIES.UPDATE_LICENSES
                            ) && (
                                <aor.FormDataConsumer>
                                    {({
                                        formData, // The whole form data
                                        ...rest
                                    }) => {
                                        return (
                                            <Field
                                                name="installation_type_ids"
                                                component={AutoCompleteInputOld}
                                                {...{
                                                    options: typeOptions
                                                }}
                                            />
                                        );
                                    }}
                                </aor.FormDataConsumer>
                            )}
                    </aor.SimpleForm>
                );
            } else {
                return <PermissionDenied />;
            }
        } else {
            return <span />;
        }
    }
}

export default ({ permissions, ...props }) => (
    <aor.Create {...props}>
        <MyCreateCompanyForm permissions={permissions} {...props} />
    </aor.Create>
);



// WEBPACK FOOTER //
// ./src/resources/Companies/Create.js